import { AbstractLifeCycle } from '@openobserve/browser-core';
export const LifeCycle = (AbstractLifeCycle);
//# sourceMappingURL=lifeCycle.js.map